import React, { useCallback, useMemo } from 'react'
import { Dialog, DialogProps } from '../'
import { makeStyles } from '@material-ui/styles'
import { ManWithFiles } from '~/assets/illustrations'
import { Box, Button, Typography } from '@material-ui/core'
import { useIsMobileScreen } from '~/hooks'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  button: {
    height: 56,
    fontWeight: 700,
    textTransform: 'none'
  }
})

export const DocumentationSentFeedback: React.FC<DialogProps> = (props) => {
  const { onClose, ...rest } = props
  const classes = useStyles()
  const isMobile = useIsMobileScreen()
  const illustrationSize = useMemo(() => isMobile ? 150 : 200, [isMobile])

  const onButtonClick = useCallback(() => {
    onClose()
    window.location.reload()
  }, [onClose])

  return (
    <Dialog maxWidth='md' onClose={onButtonClick} {...rest}>
      <Box className={classes.container}>
        <ManWithFiles width={illustrationSize} height={illustrationSize} />
        <Typography sx={{ marginTop: 6, fontWeight: 700 }} variant={isMobile ? 'airbnbH4' : 'airbnbH3'}>Documentação enviada!</Typography>
        <Typography sx={{ marginTop: 2, marginBottom: 3, textAlign: 'center' }} variant={isMobile ? 'airbnbBody2' : 'airbnbBody1'}>
          Parabéns, você finalizou a etapa de documentação! A nossa equipe agora vai avaliar os documentos enviados para continuar sua solicitação. É só aguardar.
        </Typography>
        <Button
          disabled={false}
          color='primary'
          variant='contained'
          onClick={onButtonClick}
          className={classes.button}
          size={isMobile ? 'small' : 'large'}
        >
          Acompanhar andamento
        </Button>
      </Box>
    </Dialog>
  )
}
